import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';

import { environment } from 'environments/environment';
import { CommonService } from '../../../../../common/services/Common.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { ChatService } from '../../../../../common/services/Chat.service';
import { EmailService } from '../../../../../common/services/Email.service';
import { BsModalService } from 'ngx-bootstrap';
import { FieldService } from '../../../../../common/services/Field.service';


declare var $: any;

@Component({
    moduleId: module.id,
    selector: "template-config",
    templateUrl: './template.component.html',
    styleUrls: ['./template.css'],
    providers: [CommonService, EmailService, BsModalService, FieldService]
})

@Injectable()
export class TemplateComponent implements OnInit {
    public model: any = {};
    public modelTemplate: any = {};
    public user: any = {};
    public tab: string = 'template'

    public list: any = [];
    public listAccount: any = [];
    public totalItem: number = 0;
    public totalAccount: number = 0;
    public message: { class: string, content: string } = null;
    public typeModal: string;
    public modalRef: any = {};
    public modalRef2: any = {};
    public id_delete: number;
    public files: any = [];
    public allTemplate: any = [];
    public allType: any = [];
    public typeTemplate : any = [{id: '', text:''}];
    public fields : any = [];
    public list_page_devide : any = [];
    totalPage : number = 0;
    currentPage : number = 1;

    constructor(
        private fieldService: FieldService,
        private uploadService: UploadService,
        private chatService: ChatService,
        private emailService: EmailService,
        private modalService: BsModalService,
        private commonService: CommonService,
        private toastr: ToastrService) {
        this.user = JSON.parse(localStorage.getItem('User'));
    }

    ngOnInit() {
        this.tab = 'template';
        this.typeTemplate = [
            {
                id: '0',
                text: 'Chat'
            },{
                id: '1',
                text: 'Email'
            }
        ]

        this.fields = [
            { key: 'code', title: 'Mã phiếu ghi'},
            { key: 'name', title: 'Tên'},
            { key: 'phone', title: 'Điện thoại'},
            { key: 'email', title: 'Email'},
            { key: 'address', title: 'Địa chỉ'},
            { key: 'gender', title: 'Giới tính'},
            { key: 'note', title: 'Ghi chú'},
        ];
        this.fieldService.allField({ target: 'user' }).subscribe(res => {
            if(res.status == 200) {
                res.data.forEach(e => {
                    this.fields.push({
                        key : e.key,
                        title: e.title
                    })
                });
            }
        })
        this.loadTemplate();
    }

    choiceKey(key) {
        this.modelTemplate['template_content'] = this.modelTemplate['template_content'] ? this.modelTemplate['template_content'] : '';
        this.modelTemplate['template_content'] += ' #'+key+'#';
    }

    changeTypeTemplate($event) {
        this.modelTemplate['type'] = $event.value;
    }

    changedTab(tab) {
        this.tab = tab;
        if (this.tab == 'account') {
            this.loadAccount();
        } else {
            this.loadTemplate();
        }
    }

    loadAccount(request: any = {}, sort: any = {}) {
        this.listAccount = [];
        this.emailService.listAccount(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.listAccount = res.data;
                this.totalAccount = this.listAccount.length;

            }
        });
    }

    loadTemplate(request: any = {}, sort: any = {}) {
        this.list = [];
        let templateList = [
            {
                id: '',
                text: ''
            }
        ];
        this.emailService.listTemplate(request).toPromise().then(res => {
            if (res.status == 200 && res.error == false) {
                this.list = res.data;
                this.totalItem = this.list.length;
                this.totalPage = this.totalItem % 10 != 0 ? Math.floor(this.totalItem/10) + 1 : Math.floor(this.totalItem/10);
                var begin = (this.currentPage - 1) * 10;
                var end = this.currentPage * 10;
                this.list_page_devide = this.list.slice(begin, end);
                this.list.forEach(e => {
                    templateList.push({
                        id: e.ID,
                        text: e.TEMPLATE_NAME
                    });
                });

                this.allTemplate = templateList;
            }
        });
    }

    openModalTemplate(template: TemplateRef<any>, id?: any) {
        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
            class: 'modal-lg'
        }
        this.modalRef = this.modalService.show(template, config);
        this.modelTemplate = {
            attach_file: "",
            type:"0",
            note: "",
            template_subject: "",
            template_content: "",
        };
        this.typeModal = id ? 'edit' : 'add'
        this.files = [];
        if (id) {
            this.emailService.findTemplate(id).toPromise().then(rs => {
                this.modelTemplate = rs.data;
                this.modelTemplate.attach_file = this.modelTemplate.attach_file ? this.modelTemplate.attach_file : "";
                if(this.modelTemplate.attach_file){
                    this.files = this.modelTemplate.attach_file.split(',');
                } else {
                    this.files = [];
                }
                
            })
        }
    }


    addTemplate() {
        console.log(this.modelTemplate);
        if (!this.modelTemplate.template_name || (this.modelTemplate.template_name && this.modelTemplate.template_name.trim() == "")){
            this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" };
        } else if(this.modelTemplate.type == 1 && (!this.modelTemplate.template_subject || this.modelTemplate.template_subject.trim() == "")){
            this.message = { class: "alert dark alert-danger", content: "Tiêu đề không được bỏ trống !" };
        }
        else if(!this.modelTemplate.template_content || this.modelTemplate.template_content.trim() == ""){
            this.message = { class: "alert dark alert-danger", content: "Nội dung không được bỏ trống !" };
        }
        else {
            this.emailService.createTemplate(this.modelTemplate).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                        this.toastr.error('Thêm mới thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                        this.toastr.success('Thêm mới thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });

                        this.loadTemplate();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
    }

    editTemplate() {
        this.message = null;
        if (!this.modelTemplate.template_name || (this.modelTemplate.template_name && this.modelTemplate.template_name.trim() == "")){
            this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" };
        } else if(this.modelTemplate.type == 1 && (!this.modelTemplate.template_subject || this.modelTemplate.template_subject.trim() == "")){
            this.message = { class: "alert dark alert-danger", content: "Tiêu đề không được bỏ trống !" };
        }
        else if(!this.modelTemplate.template_content || this.modelTemplate.template_content.trim() == ""){
            this.message = { class: "alert dark alert-danger", content: "Nội dung không được bỏ trống !" };
        }else {
            let payload = _.assign({}, this.modelTemplate);
            delete payload.id;
            delete payload.created_date;
            delete payload.user_created;
            delete payload.tenant_id;
            if(!payload.template_subject) payload.template_subject = "";
            this.emailService.updateTemplate(this.modelTemplate.id, payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                        this.toastr.error('Cập nhật thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                        this.toastr.success('Cập nhật thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.loadTemplate();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
                setTimeout(() => { this.message = null; }, 3000);
            });
        }
    }

    changeFile($event) {
        var files = $event.srcElement.files;
        let fileSize = files[0]? files[0].size : 0;
        if(fileSize > 5242880){
            this.toastr.error('Lỗi, dung lượng file vượt quá 5Mb', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            
        } else {
            this.uploadService.upload(files[0]).then((res: any) => {
                if (!res.error) {
                    this.files.push(this.commonService.file(res.data));
                    this.modelTemplate['attach_file'] = this.files.join(',');
                    $event.target.value = null;
                } else {
                    this.toastr.error(res.data.message, 'Lỗi', {
                        timeOut: 4000,
                        positionClass: 'toast-bottom-right'
                    });
                }
            })
        }
        

    }

    deleteFile(file) {
        this.files = _.pull(this.files, file);
        this.modelTemplate['attach_file'] = this.files.join(',');
    }

    openConfirmDelete(template: TemplateRef<any>, id) {
        this.id_delete = id;
        // this.modalRef2 = this.modalService.show(template);
        var y = confirm("Bạn có muốn xóa không?");
        if(y){
            this.submitDelete();
        }
    }

    submitDelete() {
        if (this.tab == 'template') {
            this.emailService.deleteTemplate(this.id_delete).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Xóa không thành công" };
                        this.toastr.error('Xóa không thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Xóa thành công" };
                        this.toastr.success('Xóa thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.loadTemplate();
                        // this.modalRef2.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        } else {
            this.emailService.deleteAccount(this.id_delete).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Xóa không thành công" };
                        this.toastr.error('Xóa không thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Xóa thành công" };
                        this.toastr.success('Xóa thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.loadAccount();
                        // this.modalRef2.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
    }


    openModal(template: TemplateRef<any>, id?: any) {
        this.allType = [
            {id:'', text:''},
            {
                id: '0',
                text: 'Tập thể'
            },
            {
                id: '1',
                text: 'Cá nhân'
            }
        ]
        this.loadTemplate();
        this.message = null;
        let config = {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
            class:'modal-lg'
        }
        this.modalRef = this.modalService.show(template, config);
        this.model = {};
        this.typeModal = id ? 'edit' : 'add'
        if (id) {
            this.emailService.findAccount(id).toPromise().then(rs => {
                this.model = rs.data;
            })
        }
    }

    changedTypeAccount($event){
        this.model['account_type'] = $event.value;
    }

    changedTemplate($event: any) {
        this.model['AUTO_REPLY_EMAIL_TEMPLATE_ID'] = $event.value;
    }

    add() {
        if (!this.model.EMAIL_ADDRESS)
            this.message = { class: "alert dark alert-danger", content: "Địa chỉ không được bỏ trống !" };
        else if (!this.model.INCOMING_PASSWORD)
            this.message = { class: "alert dark alert-danger", content: "Mật khẩu không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER)
            this.message = { class: "alert dark alert-danger", content: "Địa chỉ server INCOMING không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER_PORT)
            this.message = { class: "alert dark alert-danger", content: "Port INCOMING không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER_AUTH)
            this.message = { class: "alert dark alert-danger", content: "Xác thực INCOMING không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER_PROTOCOL)
            this.message = { class: "alert dark alert-danger", content: "Giao thức INCOMING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER)
            this.message = { class: "alert dark alert-danger", content: "Địa chỉ server OUTGOING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER_PORT)
            this.message = { class: "alert dark alert-danger", content: "Port OUTGOING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER_AUTH)
            this.message = { class: "alert dark alert-danger", content: "Xác thực OUTGOING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER_PROTOCOL)
            this.message = { class: "alert dark alert-danger", content: "Giao thức OUTGOING không được bỏ trống !" };
        else if (!this.model.ACCOUNT_NAME)
            this.message = { class: "alert dark alert-danger", content: "Tên tài khoản không được bỏ trống !" };
        else if (!this.model.account_type)
            this.message = { class: "alert dark alert-danger", content: "Loại tài khoản không được bỏ trống !" };
        else {
            let payload = _.assign({}, this.model);
            payload['AUTO_REPLY_EMAIL'] = this.model['AUTO_REPLY_EMAIL'] ? 1 : 0;
            this.emailService.createAccount(payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Thêm mới không thành công" };
                        this.toastr.error('Thêm mới thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Thêm mới thành công" };
                        this.toastr.success('Thêm mới thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });

                        this.loadAccount();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
    }

    edit() {
        this.message = null;
        if (!this.model.EMAIL_ADDRESS)
            this.message = { class: "alert dark alert-danger", content: "Địa chỉ không được bỏ trống !" };
        else if (!this.model.INCOMING_PASSWORD)
            this.message = { class: "alert dark alert-danger", content: "Mật khẩu không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER)
            this.message = { class: "alert dark alert-danger", content: "Địa chỉ server INCOMING không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER_PORT)
            this.message = { class: "alert dark alert-danger", content: "Port INCOMING không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER_AUTH)
            this.message = { class: "alert dark alert-danger", content: "Xác thực INCOMING không được bỏ trống !" };
        else if (!this.model.INCOMING_SERVER_PROTOCOL)
            this.message = { class: "alert dark alert-danger", content: "Giao thức INCOMING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER)
            this.message = { class: "alert dark alert-danger", content: "Địa chỉ server OUTGOING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER_PORT)
            this.message = { class: "alert dark alert-danger", content: "Port OUTGOING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER_AUTH)
            this.message = { class: "alert dark alert-danger", content: "Xác thực OUTGOING không được bỏ trống !" };
        else if (!this.model.OUTGOING_SERVER_PROTOCOL)
            this.message = { class: "alert dark alert-danger", content: "Giao thức OUTGOING không được bỏ trống !" };
        else if (!this.model.ACCOUNT_NAME)
            this.message = { class: "alert dark alert-danger", content: "Tên tài khoản không được bỏ trống !" };
        else if (!this.model.account_type)
            this.message = { class: "alert dark alert-danger", content: "Loại tài khoản không được bỏ trống !" };
        else {
            let payload = _.assign({}, this.model);
            payload['AUTO_REPLY_EMAIL'] = this.model['AUTO_REPLY_EMAIL'] ? 1 : 0;
            delete payload.ID;
            delete payload.CREATED_DATE;
            delete payload.USER_CREATED;
            delete payload.TENANT_ID;
            delete payload.INCOMING_STATUS;
            delete payload.SERVICE_GROUP;
            delete payload.OUTGOING_PASSWORD;
            delete payload.OUTGOING_STATUS;
            this.emailService.updateAccount(this.model.ID, payload).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.message = { class: "alert dark alert-danger", content: "Cập nhật không thành công" };
                        this.toastr.error('Cập nhật thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                        this.message = { class: "alert dark alert-success", content: "Cập nhật thành công" };
                        this.toastr.success('Cập nhật thành công', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.loadTemplate();
                        this.modalRef.hide();
                    }
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadTemplate();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadTemplate();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/setting/template/template.component.ts